<template>
  <div class="logout-page" :style="{ backgroundImage: `url(${designUrl}LogOut.jpeg)` }">
    <div class="logout-card">

      <div class="logout-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ba71ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </div>

      <h1 class="logout-title">Log Out</h1>
      <p class="logout-sub">Are you sure you want to log out?</p>

      <div class="btn-group">
        <button class="btn-confirm" @click="$emit('change-page', 'LandingPage')">Yes, Log Out</button>
        <button class="btn-cancel" @click="$emit('change-page', 'DashboardPage')">Cancel</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  emits: ['change-page'],
  data() {
    return {
      designUrl: '/background_designs/',
    };
  },
  mounted() {
    console.log('User logged out');
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.logout-page {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.logout-card {
  width: 100%;
  max-width: 380px;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f0e0ff;
  padding: 40px 32px 36px;
  box-shadow: 0 8px 32px rgba(186, 113, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.logout-icon {
  width: 72px;
  height: 72px;
  background: #f3eeff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.logout-title {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}

.logout-sub {
  font-size: 14px;
  color: #aaa;
  font-weight: 500;
  margin-top: 2px;
}

.btn-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 16px;
}

.btn-confirm {
  width: 100%;
  padding: 13px;
  background: #fde8e8;
  color: #991b1b;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s, transform 0.1s;
  font-family: inherit;
}

.btn-confirm:hover { background: #fbc8c8; }
.btn-confirm:active { transform: scale(0.98); }

.btn-cancel {
  width: 100%;
  padding: 13px;
  background: #eac7ff;
  color: #4a1070;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s, transform 0.1s;
  font-family: inherit;
}

.btn-cancel:hover { background: #ba71ff; color: #fff; }
.btn-cancel:active { transform: scale(0.98); }
</style>